import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { retrieveSchool, schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import { retrieveRoutine, routineSlice, selectRoutine } from "../../../redux/routine/routineSlice";
import { useAppDispatch } from "../../../app/hooks";
import { LoadState } from "../../../redux/common";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { useEffect } from "react";

interface RoutinePageTitleProps {
    schoolId: string;
    routineId: string;
}

const RoutinePageTitle = ({ schoolId, routineId }: RoutinePageTitleProps) => {
    const user = useSelector(selectUser);
    const school = useSelector(selectSchool);
    const routine = useSelector(selectRoutine);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (school.selected && school.selected.id != schoolId) {
            dispatch(schoolSlice.actions.clean());
        }
        if (school.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveSchool({ schoolId: schoolId }));
        }
    }, [schoolId, school, user]);

    useEffect(() => {
        if (routine.selected && routine.selected.id != routineId) {
            dispatch(routineSlice.actions.clean());
        }
        if (routine.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveRoutine({ routineId: routineId }));
        }
    }, [routineId, routine, user]);


    return (school.selected?.name && routine.selected?.name) ?
        <Stack sx={{ flexGrow: 1 }}>
            <Typography variant="caption" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
                {school.selected.name}
            </Typography>
            <Typography variant="subtitle1" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
                {routine.selected.name}
            </Typography>
        </Stack>
        : <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            Rotina
        </Typography>;
};

export default RoutinePageTitle;